import { ActionPayloadType, TAssetFlow } from "@cms/utils/types";
import { ISystemBase } from "@dl/declarations";
import { createSlice } from "@reduxjs/toolkit";

interface IFormState {
  entity: ISystemBase | null;
  assetFlow: TAssetFlow;
}

const initialState: IFormState = {
  entity: null,

  assetFlow: {
    selectedId: null,
    // defaultSubtype: null,
  },
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setEntity: (state, action: ActionPayloadType<ISystemBase | null>) => {
      return {
        ...state,
        entity: action.payload,
      };
    },

    setAssetFlow: (
      state,
      action: ActionPayloadType<Partial<IFormState["assetFlow"]>>,
    ) => {
      return {
        ...state,
        assetFlow: {
          ...state.assetFlow,
          ...action.payload,
        },
      };
    },

    resetFormState: () => {
      return initialState;
    },
  },
});

export const { setEntity, setAssetFlow, resetFormState } = formSlice.actions;

export default formSlice.reducer;
